<script lang="ts" setup>
  import { IconWorld } from '@tabler/icons-vue';
  import Select from 'primevue/select';
  import { setLocale } from '@/utils/locale';

  const { locale } = useI18n();

  const lang = ref([
    { name: 'English', code: 'en' },
    { name: 'Русский', code: 'ru' },
  ]);

  const changeLocale = (locale: string) => {
    setLocale(locale);
  };
</script>

<template>
  <div>
    <Select
      v-model="locale"
      class="languageSwitch"
      option-label="name"
      option-value="code"
      :options="lang"
      @value-change="changeLocale">
      <template #value="slotProps">
        <div class="flex items-center gap-4 link no-underline">
          <IconWorld class="w-16 align-center" />
          <div>
            {{ lang.find((item) => item.code === slotProps.value)?.name }}
          </div>
        </div>
      </template>
    </Select>
  </div>
</template>

<style>
  .languageSwitch {
    padding: 0 !important;
    border: 0;
  }

  .languageSwitch:hover {
    background: transparent;
  }

  .languageSwitch [data-pc-section='dropdownicon'] {
    display: none;
  }
</style>
